module.exports = __webpack_public_path__ + "img/information.320eb08c.png";